import Vue from 'vue';
import Vuex from "vuex";
import AddProduct from "./App.vue";
import Buefy from "buefy";

import ProductForm from "./components/ProductForm.vue";
import InventroyForm from "./components/InventoryForm.vue";
import AttributesForm from "./components/AttributesForm.vue";
import AttributesFormElement from "./components/AttributesFormElement.vue";
import ImagesForm from "./components/ImagesForm.vue";
import VariantForm from "./components/VariantForm.vue";
import VariantFormElement from "./components/VariantFormElement.vue";

import {postHandler, getHandler} from "./../../../services/http.js" 

Vue.use(Vuex)

Vue.use(Buefy, {
    defaultIconPack:'fas'
})

Vue.use(ProductForm)
Vue.use(InventroyForm)
Vue.use(AttributesForm)
Vue.use(AttributesFormElement)
Vue.use(ImagesForm)
Vue.use(VariantForm)
Vue.use(VariantFormElement)


const store = new Vuex.Store({
    state:{
        productData:{
            title:"",
            status:"",
            description:"",
            subcategory:"",
            currency:"",
            tax:"",
            price:0,
            cost:0,
            compareAt:0,
            classified:false,
            hasDelay:false,
            weightKg:0.00,
            warranty:"",
            filterOptions:[]
        },
        defaultImg:"",
        images:{},
        inventory:{
            trackStock:false,
            code:"",
            quantity:0
        },
        micromanage:false,
        attributes:[],
        variants:[],
        loading:false,
        filters:[]
    },
    getters:{
        productData(state){
           return state.productData
        },
        getAttributes(state){
            return state.attributes
        },
        getMicromanage(state){
            return state.micromanage
        },
        getVariants(state){
            return state.variants
        },
        getInventory(state){
            return state.inventory
        },
        isLoading(state){
            return state.loading
        },
        getAllFilters(state){
            return state.filters
        }
    },
    mutations:{
        mutateData(state, payload){
            let obj = payload.obj
            let data = payload.data
            state[obj] = data
            console.log(state[obj])
        },
        addAttribute(state){
            state.attributes.push({title:'', values:[]})
        },
        deleteAttribute(state, index){
            console.log(state.attributes)
            console.log(index)
            state.attributes.splice(index, 1)
        },
        updateAttribute(state, payload){
            state.attributes[payload.index] = payload.data 
        },
        addVariant(state){
            state.variants.push({price:0,cost:0,compareAt:0, quantity:0, code:"", hasDifPricing:false})
        },
        deleteVariant(state, index){
            state.variants.splice(index, 1)
        },
        updateVariant(state, payload){
            state.variants[payload.index] = payload.data
        },
        updateLoading(state, value){
            state.loading = value
        },
        addFilters(state, value){
            state.filters = value
        }
            
        
    },
    actions:{
        updateData({commit}, payload){
            //every change in any component input will be listened by this method and update the data.
            commit('mutateData', payload)
        },
        addAttribute({commit}){
            commit('addAttribute')
        },
        deleteAttribute({commit}, index){
            commit("deleteAttribute", index)
        },
        updateAttribute({commit}, payload){
            commit("updateAttribute", payload)
        },
        addVariant({commit}){
            commit("addVariant")
        },
        deleteVariant({commit}, index){
            commit("deleteVariant", index)
        },
        updateVariant({commit}, payload){
            commit("updateVariant", payload)
        },
        async fetchFilters({commit, state}, endpoint){
            commit("uploadLoading", true)
            var url = endpoint + `?pagina_size=10000`
            var response = await getHandler(url, {success:false, error:false})
            commit("uploadLoading", false)
            console.log(response)
            commit('addFilters', response.results)
        },
        async saveProduct({commit, state}, endpoint){
            let msgS = {
                resource:"toast",
                text:"Producto creado con exito"
            }
            let msgE = {
                resource:"toast",
                text:"No se creo el producto, chequea que estan todos los datos."
            }
            let requestBody = {
                productData:state.productData,
                images:state.images,
                defaultImg:state.defaultImg,
                inventory:state.inventory,
                micromanage:state.micromanage,
                attributes:state.attributes,
                variants:state.variants
            }
            commit("updateLoading", true)
            let response = await postHandler(endpoint, requestBody, {success:msgS, error:msgE})
            commit("updateLoading", false)
            console.log(response)
            if (response.status <= 201){
                window.location.replace("/staff/ecom/catalog/")
            }
        }
    }
})




if (document.getElementById("newProductApp")){
    new Vue({
        store,
        render: h=> h(
            AddProduct,
            {
                props:{
                    createEndpoint:document.getElementById("newProductApp")
                        .getAttribute("create-endpoint"),
                    currencyEndpoint:document.getElementById("newProductApp")
                        .getAttribute("currency-endpoint"),
                    taxEndpoint:document.getElementById("newProductApp")
                        .getAttribute("tax-endpoint"),
                    subcategoryEndpoint:document.getElementById("newProductApp")
                        .getAttribute("subcategory-endpoint"),
                    filtersUrl:document.getElementById("newProductApp")
                        .getAttribute("filters-list-create")
                }
            }
        )
    }).$mount("#newProductApp")
}